import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "burnsEliteParentToken";
const EMAIL_KEY = "burnsEliteParentEmail";

export const getStoredParentToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const getStoredParentEmail = () => localStorage.getItem(EMAIL_KEY) || "";
export const setStoredParentSession = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EMAIL_KEY, email);
};
export const clearStoredParentSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

// Authenticated parent API. Sends JWT as Authorization: Bearer.
// On 401: wipe session and redirect to /parent/login.
export const parentApi = axios.create({ baseURL: API_BASE });

parentApi.interceptors.request.use((config) => {
  const token = getStoredParentToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

parentApi.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error?.response?.status === 401) {
      clearStoredParentSession();
      // Defer so calling component shows toast first
      setTimeout(() => {
        if (!window.location.pathname.startsWith("/parent/login")) {
          window.location.href = "/parent/login";
        }
      }, 50);
    }
    return Promise.reject(error);
  }
);

// Public (unauthenticated) parent API for login / forgot / reset.
export const publicParentApi = axios.create({ baseURL: API_BASE });

export const PARENT_API_BASE = API_BASE;
